import { IThanhPhanMon } from "../../../model/response/category/IThanhPhanMon";
import { generateActionTypeIds } from "../generateActionTypeIds";
import IGenericActionType from "../IGenericActionType";

export const eThanhPhanMonActionsObj = {
    LOAD_START: undefined,
    LOAD_SUCCESS: {} as IThanhPhanMon[],
    LOAD_ERROR: "",

    SHOW_EDIT_MODAL: {} as IThanhPhanMon | undefined,
    CLOSE_EDIT_MODAL: undefined,

    SAVE_START: {} as IThanhPhanMon,
    SAVE_SUCCESS: undefined,
    SAVE_ERROR: "",

    DELETE_START: 0,
    DELETE_SUCCESS: undefined,
    DELETE_ERROR: "",
};

export const eThanhphanMonActionIds = generateActionTypeIds(eThanhPhanMonActionsObj, "THANH_PHAN_MON");
export type IThanhPhanMonActionTypes = IGenericActionType<typeof eThanhPhanMonActionsObj, "THANH_PHAN_MON">;